import React, { forwardRef } from 'react'
import { Dialog, DialogContent, Grow } from '@mui/material'
import { motion } from 'framer-motion'
import { LifestyleGoal } from 'components/LifestyleGoal'

const Transition = forwardRef(function Transition(props, ref) {
  return <Grow timeout={300} ref={ref} {...props} />
})

export default function LifestyleGoalModal({
  adjustedWorkingNetTakeHome,
  adjustedNetTakeHomeInRetirement,
  adjustedNetTakeHomeDifferencePARCOGap,
  valueOfInvestableAssets,
  parcoAnnuityRecommendationCalculator,
  onClose,
}) {
  return (
    <Dialog
      open
      onClose={onClose}
      TransitionComponent={Transition}
      fullWidth
      maxWidth={'md'}
      PaperProps={{
        sx: {
          overflow: { xs: 'auto', sm: 'visible' },
          margin: '16px',
          width: 'calc(100% - 32px)',
        },
      }}
    >
      <DialogContent sx={{ overflow: 'visible' }}>
        <motion.div
          key="scheduler"
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.95 }}
          transition={{ duration: 0.3, ease: 'easeInOut' }}
        >
          <LifestyleGoal
            isOnPageForm={false}
            adjustedWorkingNetTakeHome={adjustedWorkingNetTakeHome}
            adjustedNetTakeHomeInRetirement={adjustedNetTakeHomeInRetirement}
            adjustedNetTakeHomeDifferencePARCOGap={
              adjustedNetTakeHomeDifferencePARCOGap
            }
            valueOfInvestableAssets={valueOfInvestableAssets}
            parcoAnnuityRecommendationCalculator={
              parcoAnnuityRecommendationCalculator
            }
            closeModal={onClose}
          />
        </motion.div>
      </DialogContent>
    </Dialog>
  )
}
